export type BackNavigationState = {
  from?: string;
  fromTabBar?: boolean;
};

const DETAIL_ROUTE_PREFIXES = [
  '/post/',
  '/list/',
  '/itinerary/',
  '/place/',
  '/recommendation/',
] as const;

/** Profile detail at any of the three aliases: `/profile/:id`, `/storefront/:id`, `/book/:id`. */
export function isProfileDetailPath(pathname: string): boolean {
  return /^\/(?:profile|storefront|book)\/[^/]+\/?$/.test(pathname);
}

/** Profile city sub-page `(/profile|/storefront|/book)/:id/city/:cityName`. */
const PROFILE_CITY_PATH_RE = /^\/(profile|storefront|book)\/([^/]+)\/city\/[^/]+\/?$/;

/** True when this profile screen was reached via the mobile tab bar's own-profile tab. */
export function isFromTabBar(state: unknown): boolean {
  return !!state && typeof state === 'object' && (state as BackNavigationState).fromTabBar === true;
}

function isSafeInternalPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//');
}

export function getFromStatePath(
  state: unknown,
  currentPathWithQuery: string
): string | null {
  if (!state || typeof state !== 'object') return null;
  const candidate = (state as BackNavigationState).from;
  if (typeof candidate !== 'string') return null;
  if (!isSafeInternalPath(candidate)) return null;
  if (candidate === currentPathWithQuery) return null;
  return candidate;
}

export function getBackFallbackPath(pathname: string): string {
  const cityMatch = pathname.match(PROFILE_CITY_PATH_RE);
  if (cityMatch) {
    return `/${cityMatch[1]}/${cityMatch[2]}`;
  }
  if (pathname.startsWith('/itinerary/')) {
    return '/my-travel';
  }
  if (pathname.startsWith('/recommendation/') || isProfileDetailPath(pathname)) {
    return '/performance';
  }
  if (DETAIL_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
    return '/results';
  }
  return '/';
}
